import { uiRows } from './types-def.js';
/** `web/chronicle` (1.O-2): the Chronicle's tray and timeline strip. */
export const CHRONICLE_INTERACTIONS = uiRows([
    {
        id: 'chrono.tray.drag',
        module: 'web/chronicle',
        behavior: 'Dragging an item from the unplaced tray places it',
        owner: '1.O-2',
        since: 'exit-1b',
    },
    {
        id: 'chrono.strip.click',
        module: 'web/chronicle',
        behavior: 'Clicking the timeline strip selects the date under the pointer',
        owner: '1.O-2',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=chronicle.js.map